import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import '../styles.css';
import { Helmet } from 'react-helmet-async';
import { getMetadataBundleForStaticPage } from '../metadata/SEOmetadata.js';
import { t } from '../i18n/translationStrings.js';

const pageMetadata = getMetadataBundleForStaticPage('contact');

const ContactPage = () => {
    const [state, handleSubmit] = useForm("mbldaygo");

    if (state.succeeded) {
        return (
            <main className="contact-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>
                <Helmet>
                    <html lang={pageMetadata.htmlLang} />
                    <title>{pageMetadata.title}</title>
                    <meta name="description" content={pageMetadata.description} />
                    <meta name="keywords" content={Array.isArray(pageMetadata.keywords) ? pageMetadata.keywords.join(', ') : pageMetadata.keywords} />
                    <meta property="og:image" content={pageMetadata.og.image} />
                    <meta property="og:title" content={pageMetadata.og.title} />
                    <meta property="og:description" content={pageMetadata.og.description} />
                    <meta property="og:type" content={pageMetadata.og.type} />
                    <meta property="og:url" content={pageMetadata.og.url} />
                    <meta name="twitter:title" content={pageMetadata.twitter.title} />
                    <meta name="twitter:description" content={pageMetadata.twitter.description} />
                    <meta name="twitter:card" content={pageMetadata.twitter.card} />
                    <meta name="twitter:image" content={pageMetadata.twitter.image} />
                    <link rel="canonical" href={pageMetadata.og.url} />
                    <script type="application/ld+json">{JSON.stringify(pageMetadata.structuredData)}</script>
                </Helmet>
                <section className="contact-form" style={{ backgroundColor: 'var(--light-gray)', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)', width: '100%', maxWidth: '500px', textAlign: 'center' }}>
                    <h2 style={{ color: 'var(--highlight-color)' }}>{t('thankYou')}</h2>
                    <p>{t('messageSent')}</p>
                </section>
            </main>
        );
    }

    return (
        <main className="contact-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>
            <Helmet>
                <html lang={pageMetadata.htmlLang} />
                <title>{pageMetadata.title}</title>
                <meta name="description" content={pageMetadata.description} />
                <meta name="keywords" content={Array.isArray(pageMetadata.keywords) ? pageMetadata.keywords.join(', ') : pageMetadata.keywords} />
                <meta property="og:image" content={pageMetadata.og.image} />
                <meta property="og:title" content={pageMetadata.og.title} />
                <meta property="og:description" content={pageMetadata.og.description} />
                <meta property="og:type" content={pageMetadata.og.type} />
                <meta property="og:url" content={pageMetadata.og.url} />
                <meta name="twitter:title" content={pageMetadata.twitter.title} />
                <meta name="twitter:description" content={pageMetadata.twitter.description} />
                <meta name="twitter:card" content={pageMetadata.twitter.card} />
                <meta name="twitter:image" content={pageMetadata.twitter.image} />
                <link rel="canonical" href={pageMetadata.og.url} />
                <script type="application/ld+json">{JSON.stringify(pageMetadata.structuredData)}</script>
            </Helmet>

            <section className="contact-form" style={{ backgroundColor: 'var(--light-gray)', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)', width: '100%', maxWidth: '500px' }}>
                <h2 style={{ color: 'var(--highlight-color)', textAlign: 'center', marginBottom: '1rem' }}>{t('contactUs')}</h2>
                <p style={{ textAlign: 'center', marginBottom: '1.5rem' }}>{t('contactDescription')}</p>

                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="name" style={{ display: 'block', marginBottom: '0.5rem' }}>{t('name')}</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder={t('namePlaceholder')}
                            required
                            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--dark-gray)', backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}
                        />
                        <ValidationError prefix={t('name')} field="name" errors={state.errors} />
                    </div>

                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="email" style={{ display: 'block', marginBottom: '0.5rem' }}>{t('email')}</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder={t('emailPlaceholder')}
                            required
                            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--dark-gray)', backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}
                        />
                        <ValidationError prefix={t('email')} field="email" errors={state.errors} />
                    </div>

                    <div className="form-group" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="subject" style={{ display: 'block', marginBottom: '0.5rem' }}>{t('subject')}</label>
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            placeholder={t('subjectPlaceholder')}
                            required
                            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--dark-gray)', backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}
                        />
                        <ValidationError prefix={t('subject')} field="subject" errors={state.errors} />
                    </div>

                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                        <label htmlFor="message" style={{ display: 'block', marginBottom: '0.5rem' }}>{t('message')}</label>
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            placeholder={t('messagePlaceholder')}
                            required
                            style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--dark-gray)', backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}
                        ></textarea>
                        <ValidationError prefix={t('message')} field="message" errors={state.errors} />
                    </div>

                    <button
                        type="submit"
                        className="submit-button"
                        disabled={state.submitting}
                        style={{ display: 'block', width: '100%', padding: '0.75rem', borderRadius: '4px', backgroundColor: 'var(--highlight-color)', color: 'var(--secondary-color)', fontWeight: 'bold', cursor: 'pointer', border: 'none' }}
                    >
                        {state.submitting ? t('sending') : t('sendMessage')}
                    </button>
                </form>
            </section>
        </main>
    );
};

export default ContactPage;
